export default __webpack_public_path__ + "static/media/InsideEars_04.a049a149.png";